/* Shared audit status configuration.
 * Colors use CSS variables so they automatically adapt to dark and light themes.
 * Borders use static rgba values (CSS vars can't have opacity appended inline).
 */

export const AUDIT_STATUS_CONFIG = {
  synced:           { label: 'Synced',           color: 'var(--accent)',  bg: 'var(--blue-bg)',   border: 'rgba(79,142,247,0.3)'   },
  in_progress:      { label: 'In Progress',       color: 'var(--purple)', bg: 'var(--purple-bg)', border: 'rgba(167,139,250,0.3)'  },
  pending_customer: { label: 'Pending Customer',  color: 'var(--cyan)',   bg: 'var(--cyan-bg)',   border: 'rgba(34,211,238,0.3)'   },
  audit_completed:  { label: 'Audit Completed',   color: 'var(--green)',  bg: 'var(--green-bg)',  border: 'rgba(62,207,122,0.3)'   },
  audit_abandoned:  { label: 'Audit Abandoned',   color: 'var(--text2)',  bg: 'rgba(139,149,168,0.1)', border: 'rgba(139,149,168,0.3)' },
  pending_ca:       { label: 'Pending CA Action', color: 'var(--red)',    bg: 'var(--red-bg)',    border: 'rgba(224,82,82,0.3)'    },
};

export const CA_AUDIT_STATUSES  = ['in_progress', 'pending_customer', 'audit_completed', 'audit_abandoned'];
export const TERMINAL_STATUSES  = ['audit_completed', 'audit_abandoned'];
